import React, { useContext } from "react";
import * as API from "../../api";
import RestoreIcon from '@mui/icons-material/Restore';

const ResetFormButton = ({ task, setShowCprOrderRequestValues, setShowLastMeasurementForm }) => {
  return (<div>
    <button
      onClick={(el) => {
        setShowCprOrderRequestValues(false);
        setShowLastMeasurementForm(false);

        API.updateTask(task.id, {
          task: {
            id: task.id,
            status: 'open',
            latest_quality_measurement: null,
            order_document_verified: false,
          }
        })
      }}
    >
      <RestoreIcon fontSize={'large'}/> RESET FORM
    </button>
  </div>)
};

export default ResetFormButton;
